module.exports = __webpack_public_path__ + "img/hr-fast-inserter-hand-open.94020371.png";